import React from "react";
import NotAccess from "../../order_managment//common/userNotAccess/index";
import { IsShowOrder } from "../../utils/index";

function RestrictOrder(props) {
  if (IsShowOrder()) return props.children;
  return <NotAccess />;
}

export default RestrictOrder;
